import React, { useEffect } from "react";
import { Box, Container, Grid, Typography, useMediaQuery, useTheme } from "@mui/material";
import PageContent from "../../components/layout/container/PageContent";
import SimpleBox from "../../components/layout/container/SimpleBox";
import LatestGames from "../../components/content/LatestGames";
import NextGames from "../../components/content/NextGames";
import { apiPublicRequests, apiPublicStories } from "../../api/public";
import NewMembership from "../../components/content/NewMembership";
import { useSelector } from "react-redux";
import ImageCarousel from "../../components/layout/navigation/ImageCarousel";
import HomeMemberInfo from "../../components/content/HomeMemberInfo";

const Home = () => {

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const top = isMobile ? -100 : -150;

    const currentPersonId = useSelector(state => state.user.currentPersonId);
    const impersonate = useSelector(state => state.user.impersonate);
    const people = useSelector(state => state.user.people);

    const [requests, setRequests] = React.useState([]);
    const [stories, setStories] = React.useState([]);
    const [storiesIntervalSeconds, setStoriesIntervalSeconds] = React.useState(5);

    const person = (people ?? []).find(element => element.id === currentPersonId);

    useEffect(() => {
        if (currentPersonId) {
            apiPublicRequests({ impersonate }, (data, successFlag) => {
                if (successFlag > 0) {
                    setRequests(data.people);
                }
            });
        }
    }, [impersonate]);

    useEffect(() => {
        apiPublicStories((data, successFlag) => {
            if (successFlag > 0) {
                setStories(
                    (data.stories || []).map(story => ({
                        url: story.imageUrl,
                        title: story.title,
                        linkUrl: story.linkUrl,
                    }))
                );
                if (data.intervalSeconds) {
                    setStoriesIntervalSeconds(data.intervalSeconds);
                }
            }
        });
    }, []);

    const showMembershipCta = !Boolean(person) && (requests ?? []).length === 0;

    return (
        <PageContent
            title="#seradcb"
            paddingBottom={0}
            ctaLabel={showMembershipCta ? "Torna-te Sócio" : null}
            ctaTo={showMembershipCta ? "/register" : null}
        >
            <Box sx={{ position: "relative", top: top }}>
                <Container maxWidth="lg">
                    <SimpleBox gap={theme.spacing(6)} mt={6} flexDirection={isMobile ? "column" : "row"} alignItems="stretch">
                        <LatestGames />
                        <NextGames />
                    </SimpleBox>
                    {stories.length > 0 ? (
                        <Box mt={theme.spacing(6)}>
                            <ImageCarousel images={stories} intervalSeconds={storiesIntervalSeconds} />
                        </Box>
                    ) : null}
                    {
                        (people ?? []).length > 0 ? (
                            <HomeMemberInfo people={people} currentPersonId={currentPersonId} />
                        ) : null
                    }
                </Container>
                {
                    showMembershipCta ? <NewMembership shaddowBox={false} maxContentSize="md" mt={6} formLink={true} /> : null
                }
            </Box>
        </PageContent>
    );
}

export default Home;
